import { boot } from '@dazn/bootstrap-lib';

import { getLogLevel } from '../fflag/getLogLevel';

export const setFeaturevisorLogLevels = ({
    asyncStorage,
    levels,
    isDevMode,
    isProd,
}: {
    asyncStorage: boot.storage.AsyncStorage;
    levels: boot.optimizely.ConsumerDefinedLogLevel[] | null;
    isDevMode: boolean;
    isProd: boolean;
}) =>
    getLogLevel({
        asyncStorage,
        level: levels,
        isDevMode,
        isProd,
        type: 'featurevisor',
    });
